import { render, staticRenderFns } from "./AdminReadMessage.vue?vue&type=template&id=66b36210&scoped=true"
import script from "./AdminReadMessage.vue?vue&type=script&lang=js"
export * from "./AdminReadMessage.vue?vue&type=script&lang=js"
import style0 from "./AdminReadMessage.vue?vue&type=style&index=0&id=66b36210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b36210",
  null
  
)

export default component.exports